import { render, staticRenderFns } from "./ManageSystemContent.vue?vue&type=template&id=61925388&scoped=true&"
import script from "./ManageSystemContent.vue?vue&type=script&lang=js&"
export * from "./ManageSystemContent.vue?vue&type=script&lang=js&"
import style0 from "./ManageSystemContent.vue?vue&type=style&index=0&id=61925388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61925388",
  null
  
)

export default component.exports